module.exports = __webpack_public_path__ + "static/media/599JamesPBrawleyDrNW_2018-06-12_108.34a11107.jpg";